import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { MultiSelect } from "primereact/multiselect";
import { apiCall } from "../../../../../utils/axiosService";
import { apiResponse } from "../../../../../utils/apiResponse";
import { API_URL } from "../../../../../utils/apiRoutes";
import { commonService } from "../../../../../utils/commonService";

const Filter_MonthDowRoomTypeRatePlanChannels = ({
    para,
    show,
    closeModal,
    dropdownSelectedData
}) => {

    const yearsArr = [
        ...commonService.getPastYearForDropDown(10),
        ...commonService.getFutureYearForDropDown(10),
        new Date().getFullYear(),
    ]?.sort(function (a, b) { return a - b; });

    const [ratecodes, setratecodes] = useState([]);

    const [roomtypes, setroomtypes] = useState([]);

    const [combinedchannels, setcombinedchannels] = useState([]);

    const [months, setmonths] = useState([]);

    const [dow, setdow] = useState([]);

    const [selectedData, setselectedData] = useState({ year: new Date().getFullYear(), ratecodes: [], roomtypes: [], combinedchannels: [], months: [], dow: [] });

    const GetFilterData = async () => {
        try {
            let chartDataResponse = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_FILTER_ONE,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                    },
                },
                false
            );

            let response = apiResponse(false, chartDataResponse);
            if (response?.isValidate) {
                let _ratecodes = [];
                let _roomtypes = [];
                let _combinedchannels = [];
                let _months = [];
                let _dow = [];

                if (response?.data?.data?.combinedchannels) {
                    response?.data?.data?.combinedchannels.map((item, index) => _combinedchannels.push({ name: item.combinedchannel, code: item.combinedchannel }));
                    response?.data?.data?.ratecodes.map((item, index) => _ratecodes.push({ name: item.ratecode, code: item.ratecode }));
                    response?.data?.data?.roomtypes.map((item, index) => _roomtypes.push({ name: item.roomtype, code: item.roomtype }));
                    Object.entries(response?.data?.data?.dow).map(([code, name]) => _dow.push({ name: name[parseInt(code) + 1], code: parseInt(code) + 1 }))
                    Object.entries(response?.data?.data?.months).map(([code, name]) => _months.push({ name: name[parseInt(code) + 1], code: parseInt(code) + 1 }))
                }
                setratecodes(_ratecodes);
                setroomtypes(_roomtypes);
                setcombinedchannels(_combinedchannels);
                setmonths(_months);
                setdow(_dow);
            }
        } catch (error) { }
    };
    useEffect(() => {
        if (show) {
            GetFilterData();
        }
        if (dropdownSelectedData) {
            setselectedData(dropdownSelectedData);
        }
    }, []);

    return (
        <div
            className={`FilterPopoverBody`}
        >
            <div className="GroupNameModalHeader">
                <div className="singleDateSummaryModalHeader">
                    <h2>Filter</h2>
                </div>
                <button id={commonService.generateGlobalClickTrackerID("Filter_MonthDowRoomTypeRatePlanChannels", "filter-button-onclick", "")} className="btn-close" onClick={(e) => closeModal(selectedData)}></button>
            </div>

            <div className="singleDateSummaryModalContent">
                <Row>
                    <Col xl={12}>
                        <div className="form-groups">
                            <Form.Label>Year</Form.Label>
                            <Form.Select id={commonService.generateGlobalClickTrackerID("Filter_MonthDowRoomTypeRatePlanChannels", "year", "")}
                                value={selectedData.year}
                                onChange={(e) => {
                                    setselectedData((prev) => ({
                                        ...prev,
                                        year: Number(e.target.value),
                                    }));

                                }}
                            >
                                <option value="">Select</option>
                                {yearsArr?.map((item, index) => (
                                    <option key={index} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    </Col>

                    <Col xl={12}>
                        <div className="form-groups">
                            <Form.Label>Month</Form.Label>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("Filter_MonthDowRoomTypeRatePlanChannels", "month", "")}
                                optionLabel="name"
                                placeholder="Select Month"
                                maxSelectedLabels={0}
                                options={months}
                                value={selectedData.months}
                                onChange={
                                    (e) => setselectedData((prev) => ({
                                        ...prev,
                                        months: e.value,
                                    }))
                                }
                            />
                        </div>
                    </Col>

                    <Col xl={12}>
                        <div className="form-groups">
                            <Form.Label>DOW</Form.Label>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("Filter_MonthDowRoomTypeRatePlanChannels", "dow", "")}
                                optionLabel="name"
                                placeholder="Select DOW"
                                maxSelectedLabels={0}
                                options={dow}
                                value={selectedData.dow}
                                onChange={
                                    (e) => setselectedData((prev) => ({
                                        ...prev,
                                        dow: e.value,
                                    }))
                                }
                            />
                        </div>
                    </Col>

                    <Col xl={12}>
                        <div className="form-groups">
                            <Form.Label>Room Type</Form.Label>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("Filter_MonthDowRoomTypeRatePlanChannels", "room-type", "")}
                                optionLabel="name"
                                placeholder="Select Room Type"
                                maxSelectedLabels={0}
                                options={roomtypes}
                                value={selectedData.roomtypes}
                                onChange={
                                    (e) => setselectedData((prev) => ({
                                        ...prev,
                                        roomtypes: e.value,
                                    }))
                                }
                            />
                        </div>
                    </Col>

                    <Col xl={12}>
                        <div className="form-groups">
                            <Form.Label>Rate Plan</Form.Label>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("Filter_MonthDowRoomTypeRatePlanChannels", "rate-plan", "")}
                                optionLabel="name"
                                placeholder="Select Rate Plan"
                                maxSelectedLabels={0}
                                options={ratecodes}
                                value={selectedData.ratecodes}
                                onChange={
                                    (e) => setselectedData((prev) => ({
                                        ...prev,
                                        ratecodes: e.value,
                                    }))
                                }
                            />
                        </div>
                    </Col>

                    <Col xl={12}>
                        <div className="form-groups">
                            <Form.Label>Channels</Form.Label>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("Filter_MonthDowRoomTypeRatePlanChannels", "channels", "")}
                                optionLabel="name"
                                placeholder="Select Channels"
                                maxSelectedLabels={0}
                                options={combinedchannels}
                                value={selectedData.combinedchannels}
                                onChange={
                                    (e) => setselectedData((prev) => ({
                                        ...prev,
                                        combinedchannels: e.value,
                                    }))
                                }
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xl={12} className="text-end">
                        <Button id={commonService.generateGlobalClickTrackerID("Filter_MonthDowRoomTypeRatePlanChannels", "apply", "")}
                            className="default-btn primary-btn mt-3"
                            onClick={() => {
                                closeModal(selectedData)
                            }}
                        >
                            Apply
                        </Button>

                        <Button id={commonService.generateGlobalClickTrackerID("Filter_MonthDowRoomTypeRatePlanChannels", "cancel", "")}
                            className="default-btn secondary-btn mt-3 ms-2"
                            onClick={() => {
                                closeModal(selectedData)
                            }}
                        >
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </div>

        </div>
    );
};

export default Filter_MonthDowRoomTypeRatePlanChannels;
